import { TeamOutlined } from '@ant-design/icons';
import { FormValidatorBuilder } from '../../../../../validator/form-builder/FormValidatorBuilder.ts';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope.ts';
import { tran } from '../../../../translations/schema/TranslationSchema.ts';
import { type IWidgetType } from '../../../IWidgetType.ts';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget.ts';
import { CompanyWidgetComponent } from './CompanyWidgetComponent.tsx';
import { CompanyWidgetConfigComponent } from './CompanyWidgetConfigComponent.tsx';
import { CompanyWidgetConfigSchema } from './CompanyWidgetConfigSchema.ts';
import { type ICompanyWidget } from './ICompanyWidget.tsx';

export const CompanyWidgetType: IWidgetType<ICompanyWidget> = {
  type: WidgetType.Company,
  mainType: WidgetMainType.Container,
  category: WidgetCategory.Advanced,
  name: 'Anagrafica Azienda',
  icon: <TeamOutlined />,
  formComponent: CompanyWidgetComponent,
  createFormSchema: ({ widget, parentScope, section, page }) => {
    const widgetScope = getParentValidationScope(widget, parentScope, {
      // Aggiungo a tutti i widget figli che sono discendenti da un widget di tipo Company
      // così da poter fare riferimento al parentCompany nell'estrazione dei rappresentanti legali
      extraMeta: { parentCompany: widget.id },
    });

    return FormValidatorBuilder.createWidgetsSchemaShape(
      widget.children,
      section,
      page,
      widgetScope,
    );
  },
  previewComponent: CompanyWidgetComponent,
  configValidator: CompanyWidgetConfigSchema,
  configComponent: CompanyWidgetConfigComponent,
  translationSchema: tran.widget({}),
  rules: [],
  hasValue: false,
};
